<template>
    <v-card class="edit-user-card" light>
        <v-card-title class="card-title ma-0 pa-3">
            <v-row class="ma-0 pa-0">
                <v-col cols="auto" class="ma-0 pa-0">
                    <span>Edit User</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="ma-0 pa-0">
                    <v-icon @click="close">mdi-close</v-icon>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-form class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                    <v-col cols="6">
                        <v-text-field
                            class="user-add-input"
                            label="First name"
                            v-model="editableUser.firstName"
                            :rules="rules.required"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            class="user-add-input"
                            label="Last name"
                            v-model="editableUser.lastName"
                            :rules="rules.required"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="canEditEmail">
                        <v-text-field
                            class="user-add-input"
                            label="Email"
                            v-model="editableUser.email"
                            :rules="rules.email"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-row class="ma-0 pa-0 edit-user-actions" justify="space-around">
            <v-col cols="auto">
                <v-btn color="secondary" outlined class="card-action" @click="close">
                    Cancel
                </v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn color="secondary" class="card-action" :disabled="!canSave" @click="save">
                    Save
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: 'EditUserCard',
    props: [
        'user',
    ],

    data: () => ({
        editableUser: {
            userId: '',
            firstName: '',
            lastName: '',
            email: '',
        },
        rules: {
            required: [val => (val || '').length > 0 || 'This field is required'],
            email: [value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'Invalid e-mail.';
            }]
        }
    }),

    computed: {
        canEditEmail: function() {
            return (this.editableUser.userId || '').startsWith('auth0|');
        },
        canSave: function() {
            const hasFirstName = (this.editableUser.firstName || '').trim().length > 0;
            const hasLastName = (this.editableUser.lastName || '').trim().length > 0;
            const hasEmail = (this.editableUser.email || '').trim().length > 0;

            return this.canEditEmail ? hasFirstName && hasLastName && hasEmail : hasFirstName && hasLastName;
        }
    },

    watch: {
        user: {
            immediate: true,
            handler: function(user) {
                const parsedName = this.parseName(user);

                this.editableUser = {
                    userId: user && user.userId ? user.userId : '',
                    firstName: this.getUserField(user, ['given_name', 'first_name'], parsedName.firstName),
                    lastName: this.getUserField(user, ['last_name', 'family_name'], parsedName.lastName),
                    email: user && user.email ? user.email : '',
                };
            }
        }
    },

    methods: {
        close: function() {
            this.$emit('close_edit_user');
        },
        getUserField: function(user, fields, fallback) {
            for (let idx = 0; idx < fields.length; idx++) {
                const value = user && user[fields[idx]];

                if ((value || '').trim().length > 0) {
                    return value;
                }
            }

            return fallback;
        },
        parseName: function(user) {
            const fullName = user && user.name ? user.name.trim() : '';
            const nameParts = fullName.split(/\s+/).filter(Boolean);

            return {
                firstName: nameParts.length > 0 ? nameParts[0] : '',
                lastName: nameParts.length > 1 ? nameParts.slice(1).join(' ') : '',
            };
        },
        save: function() {
            const firstName = this.editableUser.firstName.trim();
            const lastName = this.editableUser.lastName.trim();

            const userPayload = {
                user_id: this.editableUser.userId,
                given_name: firstName,
                family_name: lastName,
            };

            if (this.canEditEmail) {
                userPayload.email = this.editableUser.email.trim();
            }

            this.$emit('edit_user', userPayload);
        }
    }
}
</script>

<style>
    .edit-user-card{
        width: 40%;
        margin: 0 auto;
        padding: 12px;
    }
    .edit-user-actions{
        padding: 12px 0 16px !important;
    }
    .card-title{
        font-family: 'Gothic' !important;
        font-weight: 800 !important;
        font-size: 1.2em !important;
    }
    .card-action{
        font-family: 'Gothic' !important;
        font-weight: 600 !important;
        font-size: 0.9em !important;
    }
    .user-add-input{
        font-family: 'Gothic' !important;
        font-weight: 400 !important;
        font-size: 0.9em !important;
    }
    .user-add-input input,
    .user-add-input label,
    .user-add-input .v-messages{
        font-family: 'Gothic' !important;
    }
</style>
